<portal-sub-nav route="enterprise-site">
  <div [class.d-none]="loading === true">
    @if (site$ | async; as site) {
      <portal-menu-context [description]="site.description" [heading]="'menu.context.site' | portalTranslate">
        <ng-template>
          <div class="nav-item__context">
            <span class="text-truncate">{{ site.name }}</span>
          </div>
        </ng-template>
      </portal-menu-context>
    }

    <!-- Site Settings -->
    <portal-sub-nav-item [params]="{ siteName: siteName$ | async }" route="enterprise-site-settings">
      <ng-template portalTransclude>
        <span>{{ 'menu.settings.site.settings' | portalTranslate }}</span>
      </ng-template>
    </portal-sub-nav-item>

    <!-- Site Service Users -->
    <portal-sub-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_SITE_SERVICES, Permission.MANAGE_SITE_SERVICES],
      }"
      [params]="{ siteName: siteName$ | async }"
      route="enterprise-site-services"
    >
      <ng-template portalTransclude>
        <span>{{ 'menu.settings.site.services' | portalTranslate }}</span>
      </ng-template>
    </portal-sub-nav-item>

    <!-- Site Locations -->
    <portal-sub-nav-item
      *portalIsAuthorized="{
        anyPermission: [Permission.VIEW_LOCATIONS, Permission.MANAGE_LOCATIONS],
      }"
      [activeRoutes]="[
        'enterprise-site-locations',
        'enterprise-site-location',
        'enterprise-site-assign-users-to-location',
      ]"
      [params]="{ siteName: siteName$ | async }"
      route="enterprise-site-locations"
    >
      <ng-template portalTransclude>
        <span>{{ 'menu.settings.site.locationGroups' | portalTranslate }}</span>
      </ng-template>
    </portal-sub-nav-item>
  </div>

  @if (loading) {
    <portal-menu-loading-indicator [withContext]="true"></portal-menu-loading-indicator>
  }
</portal-sub-nav>
